import { render } from "./CogsIcon.vue?vue&type=template&id=1a5c1cb0"
import script from "./CogsIcon.vue?vue&type=script&lang=js"
export * from "./CogsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__